import axios from 'axios';

const updateBot = async (token, contactId, status) => {

    var data = {
      "token": token,
      "contactId": contactId,
      "status": status
    };
    
    const headers = { 
        'Content-Type': 'application/json',
    };

    console.log(data);
    try {
        await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/update-bot-status', data, { headers })
    }catch(err) {
        console.log(err);
        return false
    }
};

export default updateBot